<template>
  <ServiceCard 
    title="Platform Maintenance"
    subtitle="Managed infrastructure & DevOps support"
    description="Keep your systems running smoothly with proactive maintenance, security updates, and infrastructure management."
    to="/services/platform-maintenance"
    gradient-start="#3b82f6"
    gradient-end="#1d4ed8"
    button-text="View Plans"
  />
</template>

<script setup>
</script>
